import React from 'react';
import { Grid } from '@mui/material';
import { CardViewTextRow } from 'ui/viewComponents';
import { isCredentialVerifiedAction } from '../models/Action';
import { getActionDate } from '../utils/formatDate';
import { ActionCardBase } from './ActionCardBase';
import { ActionCardModalComponentProps } from './ActionCardModalComponent';

export const ActionCardCredentialVerified: React.FC<ActionCardModalComponentProps> = ({ action }) => {
    if (!isCredentialVerifiedAction(action)) {
        return <ActionCardBase action={action} broken />;
    }
    return (
        <ActionCardBase action={action}>
            <Grid container spacing={1}>
                <Grid size={12}>
                    <CardViewTextRow title="Date" value={getActionDate(action)} />
                </Grid>
                <Grid size={12}>
                    <CardViewTextRow title="Credential" value={action.metadata.credential.id} />
                </Grid>
            </Grid>
        </ActionCardBase>
    );
};
